import { render, staticRenderFns } from "./ActivitiesOfDailyLiving.vue?vue&type=template&id=5b39f751&"
import script from "./ActivitiesOfDailyLiving.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOfDailyLiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports